import React, {useState, useContext} from 'react'
import {useStripe, useElements } from '@stripe/react-stripe-js';
import { Button, Item, Icon } from 'semantic-ui-react'
import { NotificationManager } from 'react-notifications';
import { Text, Translate, LanguageContext } from '../../helpers/language';
import { backendService } from '../../services/backendService'

const Invoice = (props) => {
  const languageContext = useContext(LanguageContext);
  const stripe = useStripe();  

  const [loading, setLoading] = useState(false);

  const {  
        invoice,   
        payment_method,
        successCallback  
    } = props;    

    const payInvoice = async (payment_intent) => {        
        if (!payment_intent || !payment_method) {
            NotificationManager.error(Translate(languageContext, 'invoice_payment_failed'))    
            return;
        }
        setLoading(true);
        try {
            const client_secret_resp = await backendService.get('/api/stripe/payment_intents/' + payment_intent);
            if (!client_secret_resp || !client_secret_resp.data || !client_secret_resp.data.client_secret) {
                NotificationManager.error(Translate(languageContext, 'invoice_payment_failed'))    
                setLoading(false);
                return;
            }        
            stripe.confirmCardPayment(client_secret_resp.data.client_secret, {
                payment_method: payment_method }).then ( paymentResult => {
                    if (paymentResult.error) {              
                        NotificationManager.error(Translate(languageContext, 'invoice_payment_failed'))    
                    } else {
                        if (paymentResult.paymentIntent.status === 'succeeded') {
                            NotificationManager.success(Translate(languageContext, 'invoice_payment_succeeded'))    
                            if (successCallback)
                                successCallback();                
                        } else {                
                            NotificationManager.error(Translate(languageContext, 'invoice_payment_failed'))  
                        }
                    }
                    setLoading(false);
                }, e =>  {
                    console.error(e);            
                    NotificationManager.error(Translate(languageContext, 'invoice_payment_failed'))  
                    setLoading(false);
                });       
        } catch (exc) {
            console.error(exc);            
            NotificationManager.error(Translate(languageContext, 'invoice_payment_failed'))  
            setLoading(false);
        }
    }

    const downloadInvoice = async (invoiceURL, invoiceName) => {
        var link = document.createElement("a");
        var editedName = invoiceName.replace("/");

        link.download = "LISIA_" + editedName;
        link.href = invoiceURL;
        link.click();
    }
 
  return (
    <Item>    
        <Item.Content>
        <Item.Description >
                <Text tid='lisia' /> - <Text tid='invoice_heading_prefix' /> 
                { invoice.lines.data[0].plan && invoice.lines.data[0].plan.nickname && <Text tid={invoice.lines.data[0].plan.nickname} /> } 
                <Text tid='invoice_heading_suffix' /> - 
                { invoice.status === 'draft' && 
                        <span style={{color: 'darkgrey'}}> <b><Text tid='invoice_scheduled'/> </b></span> 
                }
                { invoice.status === 'paid' && 
                        <span style={{color: 'green'}}> <b><Text tid='invoice_paid'/> </b></span> 
                }
                { invoice.status === 'open' && 
                        <span style={{color: 'red'}}> <b><Text tid='invoice_due' /> </b></span>
                }
                { invoice.status === 'void' && 
                        <span style={{color: 'darkgrey'}}> <b><Text tid='invoice_voided' /> </b></span>
                }
                { invoice.status === 'paid' && 
                    <Button icon labelPosition='right'
                        onClick={ () => downloadInvoice(invoice.invoice_pdf, (new Date(invoice.created * 1000)).toLocaleDateString("it-IT")) } 
                        floated='right' 
                        style={{'minWidth':'140px'}} 
                        className='scaricaFatturaBtn lisia-blue'
                    > 
                        <Text tid='subscription_download_invoice' /> 
                        <Icon name='download' />
                    </Button> 
                }
                { invoice.status === 'open' && 
                    <Button 
                    icon 
                    loading={loading}
                    labelPosition='right'
                    disabled={loading}
                    onClick={ () => payInvoice(invoice.payment_intent) } 
                    floated='right' 
                    style={{'minWidth':'140px'}} 
                    className='scaricaFatturaBtn lisia-orange'
                    > { loading ?
                        <>    
                            Loading                        
                            <Icon name='shopping cart' />
                        </> 
                        :
                        <><Text tid='subscription_pay_invoice' /> 
                        <Icon name='shopping cart' /></>
                      }
                    </Button>
                }       
            </Item.Description>
            <Item.Extra>
                { invoice.status === 'paid' ? 
                        <span><Text tid='subscription_paid_amount' />: {(invoice.amount_paid / 100).toFixed(2)} &euro;</span> : 
                        <span><Text tid='subscription_amount_due' />: {(invoice.amount_due / 100).toFixed(2)} &euro;</span>
                }
                <span><Text tid='subscription_payment_date' />: {(new Date(invoice.created * 1000)).toLocaleDateString("it-IT")}</span>
                 
            </Item.Extra>
        </Item.Content>
    </Item>
  );

}

export default Invoice